import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  UnpaidInvoiceItem,
  UnpaidInvoices,
} from '../../../models/invoices/invoice';
import { InvoiceService } from '../../../services/invoice.service';
import { TranslationEnum } from '../../../../assets/i18n/translation-enum';

@Component({
  selector: 'tg-unpaid-invoices-modal',
  templateUrl: './unpaid-invoices-modal.component.html',
  styleUrls: ['./unpaid-invoices-modal.component.scss'],
})
export class UnpaidInvoicesModalComponent {
  @Input()
  status: UnpaidInvoices;

  /** The grace period is over: drives the wording and the red styling. */
  @Input()
  suspended = false;

  /** The modal cannot be dismissed and logging out is the only way past it. */
  @Input()
  blocking = false;

  /** Only users allowed on /invoices get the button that takes them there. */
  @Input()
  canViewInvoices = false;

  @Output()
  dismissed = new EventEmitter<void>();

  @Output()
  viewInvoices = new EventEmitter<void>();

  @Output()
  loggedOut = new EventEmitter<void>();

  TranslationEnum = TranslationEnum;

  /** Keeps the modal short when a gym has let a lot of invoices pile up. */
  maxListedInvoices = 4;

  constructor(private invoiceService: InvoiceService) {}

  get listedInvoices(): UnpaidInvoiceItem[] {
    return this.status?.invoices?.slice(0, this.maxListedInvoices) || [];
  }

  get hiddenInvoiceCount(): number {
    return Math.max(
      0,
      (this.status?.invoices?.length || 0) - this.maxListedInvoices
    );
  }

  downloadUrl(invoice: UnpaidInvoiceItem): string {
    return this.invoiceService.getDownloadUrl(invoice);
  }

  get daysLeft(): number {
    return this.status?.disableNoOfDays || 0;
  }

  /** A gym with no "disable if unpaid" setting is reminded, but never suspended. */
  get hasGracePeriod(): boolean {
    return (
      !!this.status?.gracePeriodDays &&
      this.status.disableNoOfDays !== null &&
      this.status.disableNoOfDays !== undefined
    );
  }

  get isLastDay(): boolean {
    return this.hasGracePeriod && this.daysLeft === 1;
  }

  /** How much of the grace period has been used up, as a percentage. */
  get graceUsedPercent(): number {
    if (!this.hasGracePeriod) {
      return 0;
    }

    const used = (this.status.daysOverdue / this.status.gracePeriodDays) * 100;
    return Math.min(100, Math.max(0, Math.round(used)));
  }

  onBackdropClick(): void {
    if (!this.blocking) {
      this.dismissed.emit();
    }
  }
}
